import { defineStore } from 'pinia';
import {
    addBusinessProcessApi,
    getBusinessProcessListApi,
    getMyBusinessProcessListApi,
    getMyBusinessProcessWaitingListApi,
    getDoneBusinessProcessListApi,
    inquireBusinessProcessMainApi,
    deleteBusinessProcessApi,
    editBusinessProcessApi,
    postProcessAbilityApi,
    getfflineTaskApi,
    getStsCredentialApi,
    uploadAliOfflineApi,
    uploadAudioSubmitApi,
    getInterviewReportApi,
    postProcessAbilityBatchApi,
    addCandidateRemarkApi,
    getCandidateRemarkListApi,
    editCandidateRemarkApi,
    delCandidateRemarkApi,
    delProcessAbilityApi,
    putEntryStatusApi,
    putOfferStatusApi,
    putProcessStatusApi,
    getProcessSummaryGenerateLatestApi,
    postCancelInterviewApi,
    getProcessCandidateRankApi,
    postProcessRemindApi
} from "~/modules/my-interview/apis/interview.js"
import {
    getPositionGroupListApi,
    getPositionProfileMainApi
} from "~/modules/post-module/apis/post.js"
import {
    getCandidateListApi,
} from "~/modules/talents-module/apis/talents.js"
import { MessagePlugin } from 'tdesign-vue-next';
import { mockInterviewStore } from './mock-interview-store.js';

const isAdmin = localStorage.getItem('isAdmin') === 'true';
const isHR = localStorage.getItem('isHR') === 'true';
const isInterviewer = localStorage.getItem('isInterviewer') === 'true';

// 我的面试
export const interviewStore = defineStore({
    id: 'interviewStore',
    state: () => ({
        viewLoading: false, // 视图加载中
        openTalentsSummarizeInterviewId: null, // 候选人总结弹窗的面试id
        openTalentsSummarizeDialog: false, // 是否打开候选人总结弹窗
        remarkLoading: false, // 备注加载中
        remarkList: [], // 备注列表
        isNewInitiate: false, // 是否新发起面试
        isRollPoling: false, // 是否轮询
        isSynchronize: false, // 是否同步
        isFullScreen: false, // 是否全屏
        activeKey: ['1'], // 折叠面板的key
        b_height: 0, // 简历详情页的高度
        isForbid: false, // 是否禁止操作
        isViewType: 'all', // 查询个人,历史,全部: me, his, all
        openEditInterviewDialog: false, // 编辑面试能力弹窗
        chartOption: null, // 面试漏斗图
        sortList: [], // 流程排序的列表-全部
        operabilitySortList: [], // 流程排序的列表-可操作的数组
        isSort: 0, // 流程节点排序，用于修改流程
        integrityFlow: false, // 是否展示完整流程的按钮，在没有流程模板的情况下展示为true
        mitItem: null, // 当前选中的岗位id
        mitItemTitle: null, // 当前选中的岗位名称
        menuList: [], // 岗位列表
        mitTalentsList: [], // 候选人列表
        openPDFDialog: false, //打开PDF简历详情
        openDispositionDialog: false, // 是否打开面试方案配置
        openIntegrityDispositionDialog: false, // 是否打开面试完整流程配置
        openDispositionPostDialog: false, // 是否打开岗位画像模板
        openDispositionFlowDialog: false, // 是否打开流程模板
        openQuestionDialog: false, // 是否打开面试问题
        openQuestionBuilderDialog: false, // 是否打开生成问题
        openExportSummary: false, // 是否打开导出总结
        openEditFlowDialog: false, // 是否打开编辑流程弹窗
        mitDispositionPostObj: null, // 选中的岗位画像模板数据
        skeletonLoading: true, // 骨架屏加载状态
        pageLoading: false, // 页面加载状态，防止用户在页面跳转时返回
        isNavigating: false, // 导航标志，用于区分主动导航和意外离开
        isEdit: false, // 是否编辑能力
        interviewId: null,  // 面试方案id
        tableList: [],//表格数据
        unStructureList: null, // 面试方案未结构化数据
        editMitId: null, // 当前编辑面试方案id
        loading: false, // 是否正在加载中-按钮
        isFilter: false, // 是否过滤
        tLoading: false, //上传加载中
        pagination: {
            defaultCurrent: 1,
            defaultPageSize: 10,
            total: 0,
            showJumper: true
        },
        candidatePagination: { // 候选人列表分页
            defaultCurrent: 1,
            defaultPageSize: 10,
            total: 0,
            showJumper: true
        },
        mitProcessData: null, //选择的面试方案详情数据
        mitTags: [], // 经验标签list
        selectPost: null, // 选中的岗位画像
        selectFlow: null, // 选中的面试方案
        isInterviewFlow: false,
        createProcessNodes: [ // 创建的流程节点
            {
                index: 0,
                name: '选择简历',
                category: 0,
                assigneeId: JSON.parse(localStorage.getItem('userInfo'))?.userId,
                abilityIds: [],
                interviewTime: null,
                isHover: false,
                isOpen: true,
            },
            {
                index: 1,
                name: '智能测评',
                category: 1,
                assigneeId: null,
                abilityIds: [],
                interviewTime: null,
                isHover: false,
                isOpen: true,
            },
            {
                index: 3,
                name: '一面',
                category: 3,
                assigneeId: null,
                abilityIds: [],
                interviewTime: null,
                isHover: false,
                isOpen: true,
            },
            {
                index: 4,
                name: '背调',
                category: 4,
                assigneeId: null,
                abilityIds: [],
                interviewTime: null,
                isHover: false,
                isOpen: true,
            }
        ],
        eidtProcessNodes: [ // 修改的流程节点
            {
                index: 0,
                name: '选择简历',
                category: 0,
                assigneeId: JSON.parse(localStorage.getItem('userInfo'))?.userId,
                abilityIds: [],
                interviewTime: null,
                isHover: false,
                isOpen: true,
            },
            {
                index: 1,
                name: '智能测评',
                category: 1,
                assigneeId: null,
                abilityIds: [],
                interviewTime: null,
                isHover: false,
                isOpen: true,
            },
            {
                index: 3,
                name: '一面',
                category: 3,
                assigneeId: null,
                abilityIds: [],
                interviewTime: null,
                isHover: false,
                isOpen: true,
            },
            {
                index: 4,
                name: '背调',
                category: 4,
                assigneeId: null,
                abilityIds: [],
                interviewTime: null,
                isHover: false,
                isOpen: true,
            }
        ],
        editProfileAbilitiesList: [], // 修改面试方案的能力墙
        createProfileAbilitiesList: [], // 创建面试方案的能力墙
        //新的流程面试对话框
        openInterviewDialog: false,
        // 工作台用
        workbenchTableList: [], //今日面试
        workbenchFollowUpTableList: [], //候选人跟进
        workbenchPagination: { // 今日面试分页
            defaultCurrent: 1,
            defaultPageSize: 10,
            total: 0
        },
        workbenchFollowUpTablePagination: { // 候选人跟进分页
            defaultCurrent: 1,
            defaultPageSize: 10,
            total: 0
        },
        workbenchMonthPassTableList: [], // 本月候选人通过列表
        workbenchMonthPassPagination: { // 本月候选人通过分页
            defaultCurrent: 1,
            defaultPageSize: 10,
            total: 0
        },
        interviewStatusFilter: 5, // 面试状态筛选器：5-全部，6-我安排的，7-Ta人安排的，8-我参与面试的
        allAbilitiesList: [], // 全部能力列表
        localNodes: [], // 本地节点列表
        openQuestionInterviewFlowDialog: false, // 是否打开添加修改问题弹窗
        allBusinessProcessList: [], // 全部面试方案列表
        startInterviewDemandList: [], // 发起面试的招聘需求列表
        isSkeletonLoading: true, // 骨架屏加载状态
        old_demandId: null, // 旧的招聘需求id
        openPdfDialog: false, // 是否打开PDF对话框
        processSuggestQuestionData: null, // 猜你想问数据
        inputValue: '', // 输入框内容
        chatLoading: false, // 对话加载状态
        demandSideInterviewTimes: [], //需求方备选面试时间list
        demandSideInterviewScreenedUserInfo: null, //需求方对象
        isInterviewList: true, // 是否存在面试列表
        globalType: '', // 新手引导走完，设置为“global”，面试里会展示引导弹窗提示
        globalGuideCurrent: -1, // 新手引导当前步骤
        globalGuideSteps: [], // 新手引导步骤
    }),
    // 持久化配置
    // persist: true,
    actions: {
        setOpenDispositionPostDialog(value) {
            this.openDispositionPostDialog = value
        },
        /**
         * 查询岗位列表
         * @param {*} name 查询字段
         */
        async getPositionGroupList(name) {
            const res = await getPositionGroupListApi(name)
            if (res.code === 200) {
                this.menuList = res.rows || []
                this.mitItemTitle = this.menuList.find(item => item.id === this.mitItem)?.name
                // if (this.menuList.length > 0) {
                //     this.mitItem = this.menuList[0].id
                //     this.mitItemTitle = this.menuList[0].name
                //     this.getCandidateList(this.mitItem,this.candidatePagination.defaultPageSize,this.candidatePagination.defaultCurrent)
                // }
                this.skeletonLoading = false
            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },

        /**
         * 根据岗位id查询候选人列表
         * @param {*} positionId 岗位id
         * @param {*} pageSize 
         * @param {*} pageNum 
         * @returns 
         */
        async getCandidateList(positionId, pageSize, pageNum, status) {
            const res = await getCandidateListApi(positionId, pageSize, pageNum, status)
            if (res.code === 200) {
                this.mitTalentsList = res.rows
                this.mitTalentsList.forEach(item => {
                    const process = item.process
                    if (!process || process.processStatus === -1) {
                        item.interviewStatus = '待面'
                    } else if (process.processStatus === 0) {
                        item.interviewStatus = '进行中'
                    } else if (process.processStatus === 1) {
                        item.interviewStatus = '通过'
                    } else if (process.processStatus === 2) {
                        item.interviewStatus = '待定'
                    } else if (process.processStatus === 3) {
                        item.interviewStatus = '淘汰'
                    } else {
                        item.interviewStatus = '入职'
                    }
                })
                this.candidatePagination.total = res.total
            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },

        /**
         * 添加面试方案
         * @param {*} data 
         * @returns 
         */
        async addBusinessProcess(data) {
            const res = await addBusinessProcessApi(data)
            if (res.code === 200) {
                this.loading = false
                // MessagePlugin.success('添加成功')
                this.getBusinessProcessList(this.pagination.defaultCurrent, this.pagination.defaultPageSize)
            } else {
                this.loading = false
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        /**
         * 修改面试方案
         * @param {*} data 
         * @returns 
         */
        async editBusinessProcess(data, isSourceDemand = false, type) {
            const res = await editBusinessProcessApi(data)
            if (res.code === 200) {
                // this.loading = false;
                // this.tableList = this.tableList.map(item =>
                //     item.id === data.id ? res.data : item
                // )
                // MessagePlugin.success('已修改')
                if (isSourceDemand && !type) {
                    this.getBusinessProcessList(this.pagination.defaultPageSize, this.pagination.defaultCurrent, null, data.recruitmentId);
                }
                else if (!isSourceDemand && !type) {
                    this.getBusinessProcessList(this.pagination.defaultPageSize, this.pagination.defaultCurrent)
                } else if (type === 'demand') {
                    console.log('demand');
                }

            } else {
                this.loading = false
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        async editNewBusinessProcess(data) {
            const res = await editBusinessProcessApi(data)
            return res
        },
        /**
         * 获取面试方案列表
         */
        async getBusinessProcessList(pageSize, pageNum, filter, recruitmentId) {
            if (filter) {
                this.isFilter = true
            }
            this.loading = true
            let res = null
            if (this.isViewType === 'me') {
                res = await getMyBusinessProcessListApi(pageSize, pageNum, filter, recruitmentId)
            } else if (this.isViewType === 'his') {
                res = await getDoneBusinessProcessListApi(pageSize, pageNum, filter, recruitmentId)
            } else {
                res = await getBusinessProcessListApi(pageSize, pageNum, filter, recruitmentId)
            }
            if (res.code === 200) {
                this.tableList = res.rows || []

                this.tableList.forEach((item, index) => {
                    item.idEdit = false
                    item.remarksValue = item.remarks[0]?.content || ''
                    item.lastActualInterviewTime = null//默认没有实际面试时间的节点
                    if (!Array.isArray(item.remarks) || item.remarks.length === 0) {
                        item.remarks = [{ content: "" }]
                    }

                    // 获取有实际面试时间的节点
                    const nodes = item.processNodes?.filter((aitem) => aitem.actualInterviewTime !== null);
                    // 如果存在这样的节点，将最后一个节点的实际面试时间添加到item对象中
                    if (nodes && nodes.length > 0) {
                        item.lastActualInterviewTime = nodes[nodes.length - 1]?.actualInterviewTime;
                    }
                    const contentNode = item.processNodes?.find(nitem => nitem.nodeStatus === 1) ||
                        item.processNodes?.find(nitem => nitem.nodeStatus === 5) ||
                        item.processNodes?.find(nitem => nitem.nodeStatus === 3) ||
                        item.processNodes?.find(nitem => nitem.nodeStatus === 4) ||
                        null
                    const contentNodeIndex = (() => {
                        const statuses = [1, 5, 3, 4];
                        for (const status of statuses) {
                            const index = item.processNodes?.findIndex(nitem => nitem.nodeStatus === status);
                            if (index !== undefined && index >= 0) {
                                return index;
                            }
                        }
                        return null;
                    })()
                    if (contentNode) {
                        // item.interviewTime = contentNode ? contentNode.interviewTime ? contentNode.interviewTime : dayjs().format('YYYY-MM-DD HH:mm') : dayjs().format('YYYY-MM-DD HH:mm')
                        item.interviewTime = contentNode ? contentNode.interviewTime ? contentNode.interviewTime : null : null
                        item.contentNode = contentNode
                        item.assigneeId = contentNode?.assigneeId || null
                        item.nodeStatus = contentNode?.nodeStatus || null
                        item.interviewIndex = contentNodeIndex + 1;
                    } else {
                        item.interviewTime = null
                        item.contentNode = null
                        item.assigneeId = null
                        item.nodeStatus = null
                        item.interviewIndex = null;
                    }
                })
                this.pagination.total = res.total
                this.skeletonLoading = false
                this.loading = false
                // await this.getALLBusinessProcessList()
            } else {
                this.loading = false
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        /**
         * 获取当前用户还没开始的面试
         * @param {*} pageSize 
         * @param {*} pageNum 
         * @param {*} filter 
         * @param {*} recruitmentId 
         * @returns 
         */
        async getMyBusinessProcessWaitingList(pageSize, pageNum, filter, recruitmentId) {
            let res = await getMyBusinessProcessWaitingListApi(pageSize, pageNum, filter, recruitmentId)
            return res
        },

        // 获取今日面试列表
        async getMyBusinessProcessList(pageSize, pageNum, filter) {
            const res = await getMyBusinessProcessListApi(pageSize, pageNum, filter)
            if (res.code === 200) {
                this.workbenchTableList = res.rows || []
                this.workbenchTableList.forEach(item => {
                    item.idEdit = false
                    const contentNode = item.processNodes?.find(nitem => nitem.nodeStatus === 1)
                    if (contentNode) {
                        // item.interviewTime = contentNode ? contentNode.interviewTime ? contentNode.interviewTime : dayjs().format('YYYY-MM-DD HH:mm') : dayjs().format('YYYY-MM-DD HH:mm')
                        item.interviewTime = contentNode ? contentNode.interviewTime ? contentNode.interviewTime : null : null
                        item.contentNode = contentNode
                        item.assigneeId = contentNode?.assigneeId || null
                        item.nodeStatus = contentNode?.nodeStatus || null

                    } else {
                        item.interviewTime = null
                        item.contentNode = null
                        item.assigneeId = null
                        item.nodeStatus = null
                    }
                })
                this.workbenchPagination.total = res.total
                this.skeletonLoading = false
                this.loading = false
            } else {
                this.loading = false
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },

        // 获取工作台候选人跟进列表
        async getWorkbenceBusinessProcessList(pageSize, pageNum, filter) {
            const res = await getBusinessProcessListApi(pageSize, pageNum, filter)
            if (res.code === 200) {
                this.workbenchFollowUpTableList = res.rows || []
                this.workbenchFollowUpTableList.forEach(item => {
                    item.idEdit = false
                    const contentNode = item.processNodes?.find(nitem => nitem.nodeStatus === 1)
                    if (contentNode) {
                        // item.interviewTime = contentNode ? contentNode.interviewTime ? contentNode.interviewTime : dayjs().format('YYYY-MM-DD HH:mm') : dayjs().format('YYYY-MM-DD HH:mm')
                        item.interviewTime = contentNode ? contentNode.interviewTime ? contentNode.interviewTime : null : null
                        item.contentNode = contentNode
                        item.assigneeId = contentNode?.assigneeId || null
                        item.nodeStatus = contentNode?.nodeStatus || null

                    } else {
                        item.interviewTime = null
                        item.contentNode = null
                        item.assigneeId = null
                        item.nodeStatus = null
                    }
                })
                this.workbenchFollowUpTablePagination.total = res.total
                this.skeletonLoading = false
                this.loading = false
            } else {
                this.loading = false
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        // 获取工作台本月候选人通过列表
        async getWorkbenceMonthPassBusinessProcessList(pageSize, pageNum, filter) {
            const res = await getBusinessProcessListApi(pageSize, pageNum, filter)
            if (res.code === 200) {
                this.workbenchMonthPassTableList = res.rows || []
                this.workbenchMonthPassTableList.forEach(item => {
                    item.idEdit = false
                    const contentNode = item.processNodes?.find(nitem => nitem.nodeStatus === 1)
                    if (contentNode) {
                        // item.interviewTime = contentNode ? contentNode.interviewTime ? contentNode.interviewTime : dayjs().format('YYYY-MM-DD HH:mm') : dayjs().format('YYYY-MM-DD HH:mm')
                        item.interviewTime = contentNode ? contentNode.interviewTime ? contentNode.interviewTime : null : null
                        item.contentNode = contentNode
                        item.assigneeId = contentNode?.assigneeId || null
                        item.nodeStatus = contentNode?.nodeStatus || null

                    } else {
                        item.interviewTime = null
                        item.contentNode = null
                        item.assigneeId = null
                        item.nodeStatus = null
                    }
                })
                this.workbenchMonthPassPagination.total = res.total
                this.skeletonLoading = false
                this.loading = false
            } else {
                this.loading = false
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },
        async getALLBusinessProcessList(pageSize = 10, pageNum = 1) {
            const res = await getBusinessProcessListApi(pageSize, pageNum)
            if (res.code === 200) {
                const tableList = res.rows || []

                // 这里应处理 tableList（原来误用 this.tableList，会导致未处理/处理错对象）
                tableList.forEach((item, index) => {
                    item.idEdit = false
                    item.remarksValue = item.remarks[0]?.content || ''
                    item.lastActualInterviewTime = null//默认没有实际面试时间的节点
                    if (!Array.isArray(item.remarks) || item.remarks.length === 0) {
                        item.remarks = [{ content: "" }]
                    }

                    // 获取有实际面试时间的节点
                    const nodes = item.processNodes?.filter((aitem) => aitem.actualInterviewTime !== null);
                    // 如果存在这样的节点，将最后一个节点的实际面试时间添加到item对象中
                    if (nodes && nodes.length > 0) {
                        item.lastActualInterviewTime = nodes[nodes.length - 1]?.actualInterviewTime;
                    }
                    const contentNode = item.processNodes?.find(nitem => nitem.nodeStatus === 1) ||
                        item.processNodes?.find(nitem => nitem.nodeStatus === 5) ||
                        item.processNodes?.find(nitem => nitem.nodeStatus === 3) ||
                        item.processNodes?.find(nitem => nitem.nodeStatus === 4) ||
                        null
                    if (contentNode) {
                        // item.interviewTime = contentNode ? contentNode.interviewTime ? contentNode.interviewTime : dayjs().format('YYYY-MM-DD HH:mm') : dayjs().format('YYYY-MM-DD HH:mm')
                        item.interviewTime = contentNode ? contentNode.interviewTime ? contentNode.interviewTime : null : null
                        item.contentNode = contentNode
                        item.assigneeId = contentNode?.assigneeId || null
                        item.nodeStatus = contentNode?.nodeStatus || null
                        item.interviewIndex = index + 1;
                    } else {
                        item.interviewTime = null
                        item.contentNode = null
                        item.assigneeId = null
                        item.nodeStatus = null
                        item.interviewIndex = null;
                    }
                })
                this.allBusinessProcessList = tableList
                const seriesData = []
                const allNum = tableList?.length || 0
                if (allNum > 0) {
                    seriesData.push({
                        value: allNum,
                        name: '面试简历总数',
                        itemStyle: { color: '#246EFF' }
                    })
                }
                const processStatusNum = (tableList.filter(item => item.processStatus === 1))?.length || 0
                if (processStatusNum > 0) {
                    seriesData.push({
                        value: processStatusNum,
                        name: '通过面试简历',
                        itemStyle: { color: '#80E2FF' }

                    })
                }
                const roundsPassedNum = (tableList.filter(item => item.roundsPassed > 1))?.length || 0
                if (roundsPassedNum > 0) {
                    seriesData.push({
                        value: roundsPassedNum,
                        name: '通过初面数量',
                        itemStyle: { color: '#00B2FF' }
                    })
                }
                const seriesDataTitle = seriesData.map(item => item.name) || []
                this.chartOption = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c}份'
                    },
                    // toolbox: {
                    //   orient: 'vertical',
                    //   top: 'center',
                    //   feature: {
                    //     dataView: { readOnly: false },
                    //     restore: {},
                    //     saveAsImage: {}
                    //   }
                    // },
                    legend: {
                        orient: 'vertical',
                        right: '5%',       // 距离右边5%的位置，避免贴边
                        top: 'center',     // 垂直居中
                        icon: 'circle',
                        itemGap: 20,
                        textStyle: {
                            fontSize: 14,
                            color: '#4E5969',
                        },
                        data: seriesDataTitle
                    },
                    series: [
                        {
                            name: '面试方案',
                            type: 'funnel',
                            width: '70%',
                            height: '70%',
                            left: 'center',
                            top: '15%',
                            gap: 2,
                            label: {
                                show: true,
                                position: 'left',
                                formatter: '{b}: {c}份',
                                fontSize: 14,
                                // 设置标签位置偏移量 ▼
                                offset: [10, 0],  // 水平偏移10像素
                                // 确保标签有足够空间 ▼
                                padding: [5, 0, 5, 30],// 上右下左内边距
                                color: '#4E5969',
                            },
                            labelLine: {
                                show: true,
                                length: 60,    // 第一段线长度
                                length2: 40,   // 第二段线长度（折线）
                                smooth: false, // 折线
                                lineStyle: {
                                    width: 1,
                                    type: 'solid'
                                }
                            },

                            itemStyle: {
                                borderColor: '#fff',
                                borderWidth: 1
                            },
                            data: seriesData
                        }
                    ]
                }
            }
        },

        /**
         * 面试方案详情页
         * @param {*} id 
         * @returns 
         */
        async inquireBusinessProcessMain(id, status) {
            if (!id) {
                return
            }

            // 如果面试流程id小于0，则直接使用mock数据（不请求接口）
            const idNum = Number(id);
            if (idNum < 0) {
                const MockStore = mockInterviewStore();
                const mockData = MockStore.getMockData?.();
                if (mockData) {
                    this.mitProcessData = mockData;
                    this.isInterviewFlow = this.inTheProcess(this.mitProcessData?.processNodes, this.mitProcessData?.processStatus);
                    this.mitItem = this.mitProcessData.positionId;
                    const tags = this.mitProcessData?.processProfile?.tags || [];
                    if (tags.length > 0) {
                        tags.forEach(item => {
                            item.isCheck = false;
                        });
                    }
                    this.mitTags = tags;
                    return { code: 200, data: mockData };
                }
            }

            const res = await inquireBusinessProcessMainApi(id)
            if (res.code === 200 && res.data) {
                this.mitProcessData = res.data
                this.isInterviewFlow = this.inTheProcess(this.mitProcessData?.processNodes, this.mitProcessData?.processStatus)
                this.mitItem = this.mitProcessData.positionId
                const tags = this.mitProcessData?.processProfile?.tags || []
                if (tags.length > 0) {
                    tags.forEach(item => {
                        item.isCheck = false
                    })
                }
                this.mitTags = tags
                // await this.getPositionGroupList(null)
                //this.getCandidateList(this.mitItem, this.candidatePagination.defaultPageSize, this.candidatePagination.defaultCurrent, ({ interviewStatus: [status] } || null))
            } else {
                if (res.code !== 401) {
                    MessagePlugin.error(res.msg)
                }
            }
            return res
        },

        /**
         * 删除面试方案
         * @param {*} ids 
         * @returns 
         */
        async deleteBusinessProcess(ids) {
            const res = await deleteBusinessProcessApi(ids)
            return res
        },

        /**
         * 根据流程详情判断应该跳转到那个页面
         */
        async goToview(data, id, isOpen) {
            if (data.processStatus && (data.processStatus !== 2)) { //已完成的流程直接跳转到总结
                if (isOpen) {
                    this.isRollPoling = false;
                } else {
                    this.isRollPoling = true;
                }
                return {
                    path: '/interview-flow/summarize',
                    interviewId: id,
                    nodeId: 'summary',
                    category: 99
                }
            } else {
                const flowList = data.processNodes //获取到流程
                const mitflowItem = flowList.find(item => [1, 5].includes(item.nodeStatus)) //判断哪一个是正在进行的节点
                if (mitflowItem) { //如果有则传对应的节点
                    let path = null
                    if (mitflowItem.category === 0) {
                        path = '/interview-flow'
                    } else if (mitflowItem.category === 1) {
                        path = '/interview-flow/assessment'
                    }
                    else if (mitflowItem.category === 3 || mitflowItem.category === 5 || mitflowItem.category === 6) {
                        path = '/interview-flow/course'
                    } else if (mitflowItem.category === 4) {
                        path = '/interview-flow/investigate'
                    }
                    return {
                        path: path,
                        interviewId: id,
                        nodeId: mitflowItem.id,
                        category: mitflowItem.category
                    }
                } else { //没有则返回第一个
                    // 是不是还有待定的节点
                    const pendingNode = flowList.find(item => [3].includes(item.nodeStatus))
                    if (pendingNode) {
                        return {
                            path: '/interview-flow',
                            interviewId: id,
                            nodeId: pendingNode.id,
                            category: pendingNode.category
                        }
                    } else {
                        return {
                            path: '/interview-flow',
                            interviewId: id,
                            nodeId: flowList[0].id,
                            category: flowList[0].category
                        }
                    }
                }
            }
        },
        /**
         * 查询画像详情
         * @param {*} positionId 画像id
         * @returns 
         */
        async getPositionProfileMain(id) {
            const res = await getPositionProfileMainApi(id)
            return res
        },
        /**
         * 判断流程已经进入到面试环节，用于隐藏上传简历节点的重新选择简历按钮
         */
        inTheProcess(flow, status) {
            if (flow) {
                if (status > 0) {
                    return false
                } else {
                    //TODO 这里逻辑看不懂
                    const mitData = flow.filter(item => (item.category !== 0 && item.category !== 1 && item.nodeStatus > 0)) || []
                    if (mitData.length > 0) {
                        return false
                    } else {
                        return true
                    }

                }
            } else {
                return false
            }
        },
        async postProcessAbility(data) {
            const res = await postProcessAbilityApi(data)
            return res
        },
        async postProcessAbilityBatch(data) {
            const res = await postProcessAbilityBatchApi(data)
            return res
        },
        /**
         * 查询语音的内容
         * @param {*} taskId 
         * @returns 
         */
        async getfflineTask(taskId) {
            const res = await getfflineTaskApi(taskId)
            return res
        },
        /**
         * 流程排序-函数：根据prevId对数组进行排序  
         */
        sortArrayByPrevId(arr) {
            if (!arr || arr.length === 0) return [];

            const sortedArr = [];
            const processedIds = new Set(); // 记录已处理的id，防止循环引用
            const allIds = new Set(arr.map(item => item.id)); // 所有有效的id

            // 找到所有起始元素（prevId为null或prevId不在有效id中）
            const startItems = arr.filter(item =>
                item.prevId === null || !allIds.has(item.prevId)
            );

            // 如果没有找到起始元素，取第一个元素作为起始
            if (startItems.length === 0) {
                startItems.push(arr[0]);
            }

            // 从每个起始元素开始构建排序链
            startItems.forEach(startItem => {
                if (processedIds.has(startItem.id)) return;

                let current = startItem;
                // 遍历并构建排序后的数组  
                while (current && !processedIds.has(current.id)) {
                    sortedArr.push(current);
                    processedIds.add(current.id);
                    const nextId = current.id;
                    current = arr.find(item =>
                        item.prevId === nextId && !processedIds.has(item.id)
                    );
                }
            });

            // 如果还有未处理的元素（孤立节点），添加到末尾
            arr.forEach(item => {
                if (!processedIds.has(item.id)) {
                    sortedArr.push(item);
                    processedIds.add(item.id);
                }
            });

            return sortedArr;
        },
        /**
         * 获取sts临时访问凭证
         */
        async getStsCredential() {
            const res = await getStsCredentialApi()
            return res
        },
        /**
         * 创建面试离线任务
         */
        async uploadAliOffline(data) {
            const res = await uploadAliOfflineApi(data)
            return res
        },
        /**
         * 提交面试语音-v2
         */
        async uploadAudioSubmit(data) {
            const res = await uploadAudioSubmitApi(data)
            return res
        },
        /**
         * 获取面试报告
         */
        async getInterviewReport(id) {
            const res = await getInterviewReportApi(id)
            return res
        },
        /**
         * 新增备注信息
         */
        async addRemarkData(data) {
            const res = await addCandidateRemarkApi(data)
            this.tableList.forEach(item => {
                if (item.id === data.processId) {
                    item.remarkCount++
                }
            })
            return res
        },
        /**
         * 获取备注信息
         */
        async getRemarkListByCandidateId(data) {
            this.remarkLoading = true
            const res = await getCandidateRemarkListApi(data);
            this.remarkList = res.rows
            this.remarkLoading = false
            console.log(res)
            return res;// this.remarkList()
        },
        /**
         * 删除备注信息
         * @returns {Promise<axios.AxiosResponse<any>>}
         */
        async deleteRemarkData(id, flowId) {
            const res = await delCandidateRemarkApi(id)
            this.remarkList = this.remarkList.filter(item => item.id !== id)
            this.tableList.forEach(item => {
                if (item.id === flowId) {
                    item.remarkCount = item.remarkCount - 1 > 0 ? item.remarkCount - 1 : 0
                }
            })
            return res
        },
        /**
         * 编辑备注信息
         * @returns
         */
        async editRemarkData(data) {
            const res = await editCandidateRemarkApi(data)
            this.remarkList.forEach(item => {
                if (item.id === data.id) {
                    item.content = data.content
                }
            })
            return res
        },
        /**
         * delProcessAbilityApi
         */
        async deleteProcessAbilities(ids) { return await delProcessAbilityApi(ids) },



        /**
         * 更新offer状态
         */
        async putOfferStatus(data) {
            const res = await putOfferStatusApi(data)
            return res
        },
        /**
         * 更新入职状态
         */
        async putEntryStatus(data) {
            const res = await putEntryStatusApi(data)
            return res
        },
        /**
         * 更新面试状态
         */
        async putProcessStatus(data) {
            const res = await putProcessStatusApi(data)
            return res
        },
        /**
         * 获取最新的面试总结
         */
        async getProcessSummaryGenerateLatest(processId) {
            // 如果面试流程id小于0，则直接使用mock数据（不请求接口）
            const idNum = Number(processId);
            if (idNum < 0) {
                const MockStore = mockInterviewStore();
                return MockStore.getMockProcessSummaryGenerateLatest?.(processId) || {
                    code: 200,
                    msg: '操作成功',
                    data: {
                        id: null,
                        processId: String(processId),
                        executiveSummary: null,
                        delphiRoundtableMinutes: null,
                        generateStatus: 1,
                        errorMessage: null
                    }
                };
            }

            const res = await getProcessSummaryGenerateLatestApi(processId)
            return res
        },
        /**
         * 生成面试总结
         */
        async postCancelInterview(data) {
            const res = await postCancelInterviewApi(data)
            return res
        },
        /**
         * 获取流程候选人排名情况
         */
        async getProcessCandidateRank(processId, type = 0) {
            // 如果面试流程id小于0，则直接使用mock数据（不请求接口）
            const idNum = Number(processId);
            if (idNum < 0) {
                const MockStore = mockInterviewStore();
                const processData = this.mitProcessData || MockStore.getMockData?.();
                const candidateId = processData?.candidateId;
                const candidateName = processData?.candidate?.name || processData?.candidateName;
                const processStatus = processData?.processStatus;
                const matchScore = processData?.score;

                return MockStore.getMockCandidateRank?.(processId, candidateId, candidateName, type, processStatus, matchScore) || {
                    code: 200,
                    msg: '操作成功',
                    data: {
                        rangeDetail: [],
                        total: 0,
                        range: 0,
                        type: type,
                        processStatus: null,
                        matchScore: null
                    }
                };
            }

            const res = await getProcessCandidateRankApi(processId, type)
            return res
        },
        /**
         * 催办面试官提交面试结果
         */
        async postProcessRemind(data) {
            const res = await postProcessRemindApi(data)
            return res
        }

    },
});
